async function getEncryptionPublicKey(account: string): Promise<string> {
  const encryptionPublicKey = await window.ethereum.request({
    method: "eth_getEncryptionPublicKey",
    params: [account],
  });
  return encryptionPublicKey as string;
}

export default getEncryptionPublicKey;
